import { render, staticRenderFns } from "./UserCompanyUpdateModal.vue?vue&type=template&id=0f25f2a8&"
import script from "./UserCompanyUpdateModal.vue?vue&type=script&lang=js&"
export * from "./UserCompanyUpdateModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports